import { fork, put, all, call, take, race, delay } from "redux-saga/effects";

import {
  setClientsWithFailingNotifications,
  startNotificationsPolling,
  stopNotificationsPolling,
} from "../store/notificationsSlice";

import { callApi } from "./helpers/api";

import { getFailingNotifications } from "../api/ClientNotifications";

const POLLING_INTERVAL = 5 * 60 * 1000;

function* pollNotifications() {
  while (true) {
    try {
      const data = yield callApi(getFailingNotifications);
      yield put(setClientsWithFailingNotifications(data));
    } catch (err) {
      console.error("Updating notifications failed", err);
    }
    yield delay(POLLING_INTERVAL);
  }
}

function* watchPollNotifications() {
  while (true) {
    yield take(startNotificationsPolling().type);
    yield race([
      call(pollNotifications),
      take(stopNotificationsPolling().type),
    ]);
  }
}

export default function* rootSaga() {
  yield all([fork(watchPollNotifications)]);
}
